
















import {TotalSection} from "@/models/LobbyDataResponse.model";
import TimelineLite from 'gsap/TimelineLite'
import numeral from 'numeral';
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from "vue-property-decorator";

@Component({})
export default class TotalSubSectionComponent extends Vue {

  @Prop() private total!: TotalSection
  @Prop() private withLastUpdateDate!: boolean

  private value: number = 0

  mounted() {
    let timelineLite: any = new TimelineLite()
    timelineLite.to(this.$data, 0.5, {'value': this.total.value})
  }

  get animatedVal(): string {
    var originalValue = numeral(this.value)
    return originalValue.format('0,0')
  }

  onTotalClick(total: any): void {
    this.$router.push({name: total.routingInfo})
  }
}
